import {
	id,
	mapObject,
	mapObjectV,
	callObject,
	unpackObject,
	unpackFunction,
	isWholeObjectValid,
} from './utilFunctions.js';

export default (handleResponse, endpoint, transform = id) => ({
	inputBoundValidationFns: {},
	neverSubmitted: true,
	isResponseTextShowing: false,
	responseTextHider: null,
	isSubmitting: false,
	responseData: null,
	submitIf(condition) {
		if (condition) {
			this.submit();
		}
	},
	submit() {
		const result = callObject(
			mapObjectV(unpackFunction, this.inputBoundValidationFns)
		);
		if (isWholeObjectValid(result)) {
			const data = unpackObject(result);
			this.responseData = null;
			this.isSubmitting = true;
			this.isResponseTextShowing = false;
			if (this.responseTextHider) {
				clearTimeout(this.responseTextHider);
			}
			this.neverSubmitted = false;
			fetch(endpoint, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: transform(data),
			}).then((resp) => {
				handleResponse(resp)?.then((data) => {
					this.responseData = data;
					this.isSubmitting = false;
					this.isResponseTextShowing = true;
					this.responseTextHider = setTimeout(
						() => (this.isResponseTextShowing = false),
						5000
					);
				});
			});
		}
	},
});
